import { v } from "convex/values";
import {
  internalControl,
  defineTableWithInternalControl,
} from "../../../lib/shared/validators";

export const expenseCategory = v.union(
  v.literal("material"),
  v.literal("fuel"),
  v.literal("travel"),
  v.literal("third_party"),
  v.literal("indirect"),
  v.literal("other"),
);

export const validatorWorkOrderExpense = v.object({
  workOrderId: v.id("work_orders"),
  category: expenseCategory,
  description: v.optional(v.string()),
  quantity: v.optional(v.number()),
  unitCost: v.optional(v.number()),
  total: v.number(),
  productId: v.optional(v.id("products")),
  receiptUrl: v.optional(v.string()),
  date: v.optional(v.number()),
  paidTo: v.optional(v.string()),
  notes: v.optional(v.string()),
  internalControl,
});

export const work_order_expenses = defineTableWithInternalControl(
  validatorWorkOrderExpense,
)
  .index("by_work_order", ["workOrderId"])
  .index("by_category", ["category"])
  .index("by_work_order_and_category", ["workOrderId", "category"])
  .index("by_product", ["productId"])
  .index("by_company_and_work_order", [
    "internalControl.companyId",
    "workOrderId",
  ])
  .index("by_branch_and_work_order", [
    "internalControl.branchId",
    "workOrderId",
  ]);
